export interface LoginRequest {
  username: string;
  password: string;
}

export interface Login {
  role: string;
  web_token: string;
}

export interface UserAuth {
  username: string;
  token: string;
  role: string;
}

export function LoginActions() {
  function createLoginRequest(
    username: string,
    password: string
  ): LoginRequest {
    return {
      username: username,
      password: password,
    };
  }

  function loginResponse(role: string, web_token: string): Login {
    return {
      role: role,
      web_token: web_token,
    };
  }

  function createUserAuth(
    username: string,
    token: string,
    role: string
  ): UserAuth {
    return {
      username: username,
      token: token,
      role: role,
    };
  }

  function deserialize(username: string, object: any): UserAuth {
    const parseResponse = JSON.parse(JSON.stringify(object));
    return createUserAuth(
      username,
      parseResponse.web_token,
      parseResponse.role
    );
  }

  return {
    createLoginRequest,
    loginResponse,
    createUserAuth,
    deserialize,
  };
}
